<template>
    <div class="page">
        <div class="pageHeader" v-if="!reverseHeader">
            <div>
                <div class="pageHeader__title"><slot name="headerTitle"></slot></div>
                <div class="pageHeader__description"><slot name="headerDescription"></slot></div>
            </div>
        </div>
    
        <div class="pageHeader" v-if="reverseHeader">
            <div>
                <div class="pageHeader__description"><slot name="headerTitle"></slot></div>
                <div class="pageHeader__title"><slot name="headerDescription"></slot></div>
            </div>
        </div>
    
        <div class="pageTopBar">
            <div class="pageTopBar__inner">
                <slot name="topBar"></slot>
            </div>
        </div>
    
        <div class="pageMainSection">
            <div class="pageMainSection__inner">
                <div class="pageMainSection__content">
                    <div class="pageDataLoadingInfo" v-if="!contentState.isInitDataReady">
                        <!--                <pre>{{ contentState }}</pre>-->

                        <div v-if="!contentState.isInitDataReady && contentState.pending">
                            <div class="xCard infoBlock">
                                <iSpin size="large"></iSpin>
                                <span>{{ gettext('Идёт загрузка данных...') }}</span>
                            </div>
                        </div>

                        <div v-if="!contentState.isInitDataReady && !contentState.pending">
                            <div class="xCard infoBlock">
                                <div>{{ contentState.notExistText }}</div>
                                <router-link :to="{ name: 'KeywordsManagement' }">
                                    <button href="" class="button button--primary" style="margin-left: 1.5em">{{ gettext('Добавить ключевые фразы') }}</button>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    
                    <slot name="main" v-if="contentState.isInitDataReady"></slot>
                </div>
                <div v-if="sidebar" class="pageMainSection__sidebar xCard">
                    <slot name="sidebar"></slot>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from 'vue'
import {Spin} from "view-design";

Vue.component('iSpin', Spin);

export default {
    name: 'zPage',
    components: {},
    props: {
        reverseHeader: {
            type: Boolean,
            required: false,
            default: false,
        },
        sidebar: {
            type: Boolean,
            required: false,
            default: false,
        },
        contentState: {
            type: Object,
            required: true,
            default: function() {
                return {
                    pending: true,
                    isInitDataReady: false,
                    notExistText: this.gettext('Данных нет'),
                    ...this.contentState,
                }
            },
        },
    },
    watch: {
        contentState(value, oldValue) {
            // console.log(oldValue, value);
        }
    }
}
</script>

<style lang="less">
//@import "./node_modules/view-design/src/styles/components/page.less";

    .pageHeader {
        display: grid;
        grid-template-columns: 1fr 260px;
        grid-gap: 20px;
        a {
            padding: initial;
        }
    }

    .pageTopBar {
        display: grid;
        grid-template-columns: 1fr 260px;
        grid-gap: 20px;
        .pageTopBar__inner {
            display: flex;
            justify-content: space-between;
        }
    }

    .pageDataLoadingInfo {
        font-size: 15px;
        font-weight: 700;
    }
    
    .pageMainSection__inner {
        display: grid;
        grid-template-columns: 1fr 260px;
        grid-gap: 20px;
    }
    
    .pageMainSection__content {
        flex-basis: 100%;
        min-width: 730px;
    }
    
    .pageMainSection__sidebar {
        display: flex;
        flex-flow: column;
        margin-top: 0 !important;
        padding: 20px;
        min-width: 200px;
        height: 100%;
    }
    
    .xCard.infoBlock {
        height: 120px;
        width: 600px;
        padding: 30px;
        font-size: 14px !important;
        align-items: center !important;
        background: rgb(255 255 255 / 85%) !important;
        span {
            margin-left: 20px;
        }
    }

</style>
